import { createReducer } from 'typesafe-actions';

import {
  createCreditCardLeadHydrationConfigAction,
  createLeadHydrationConfigAction,
  getLeadHydrationConfigsBySubAccountUuidAction,
} from './actions';
import type { LeadHydrationAction, LeadHydrationState } from './types';

export const initialLeadHydrationState: LeadHydrationState = {
  bySubAccountUuid: {},
};

/**
 * @see https://github.com/piotrwitek/typesafe-actions#createreducer
 */
export const leadHydrationReducer = createReducer<
  LeadHydrationState,
  LeadHydrationAction
>(initialLeadHydrationState)
  .handleAction(
    getLeadHydrationConfigsBySubAccountUuidAction.success,
    (state, { payload: { subAccountUuid, response } }) => {
      return {
        ...state,
        bySubAccountUuid: {
          ...state.bySubAccountUuid,
          [subAccountUuid]: response,
        },
      };
    }
  )
  .handleAction(
    [
      createLeadHydrationConfigAction.success,
      createCreditCardLeadHydrationConfigAction.success,
    ],
    (state, { payload: { subAccountUuid }, payload }) => {
      return {
        ...state,
        bySubAccountUuid: {
          ...state.bySubAccountUuid,
          [subAccountUuid]: [
            ...state.bySubAccountUuid[subAccountUuid],
            payload,
          ],
        },
      };
    }
  );
